'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _setImmediate2 = require('babel-runtime/core-js/set-immediate');

var _setImmediate3 = _interopRequireDefault(_setImmediate2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames3 = require('classnames');

var _classnames4 = _interopRequireDefault(_classnames3);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _components = require('components');

var _utils = require('utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SiteHeaderNav = function (_React$Component) {
  (0, _inherits3.default)(SiteHeaderNav, _React$Component);

  function SiteHeaderNav() {
    (0, _classCallCheck3.default)(this, SiteHeaderNav);

    var _this = (0, _possibleConstructorReturn3.default)(this, (SiteHeaderNav.__proto__ || (0, _getPrototypeOf2.default)(SiteHeaderNav)).call(this));

    _this.handleWindowClick = _this.handleWindowClick.bind(_this);
    _this.handleNavSwitchClick = _this.handleNavSwitchClick.bind(_this);
    _this.handleMouseMove = _this.handleMouseMove.bind(_this);

    _this.state = { open: false };
    return _this;
  }

  (0, _createClass3.default)(SiteHeaderNav, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return this.state.open != nextState.open || this.state.getMegascansDropdownHidden != nextState.getMegascansDropdownHidden || this.props.loggedIn != nextProps.loggedIn;
    }
  }, {
    key: 'handleNavSwitchClick',
    value: function handleNavSwitchClick(ev) {
      var _this2 = this;

      this.setState({ open: !this.state.open });

      (0, _setImmediate3.default)(function () {
        if (!_this2.state.open) {
          window.removeEventListener('click', _this2.handleWindowClick);
        } else {
          window.addEventListener('click', _this2.handleWindowClick);
        }
      });
    }
  }, {
    key: 'handleWindowClick',
    value: function handleWindowClick() {
      this.setState({ open: false });
      window.removeEventListener('click', this.handleWindowClick);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener("click", this.handleWindowClick);
    }
  }, {
    key: 'handleGetMegascansClicked',
    value: function handleGetMegascansClicked(ev) {
      this.setState({
        getMegascansDropdownHidden: true
      });

      window.addEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'handleMouseMove',
    value: function handleMouseMove() {
      this.setState({
        getMegascansDropdownHidden: false
      });

      window.removeEventListener('mousemove', this.handleMouseMove);
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames, _classnames2;

      var styles = require('./SiteHeaderNav.scss');
      var _props = this.props,
          loggedIn = _props.loggedIn,
          packs = _props.packs;
      var _state = this.state,
          open = _state.open,
          getMegascansDropdownHidden = _state.getMegascansDropdownHidden;


      var classes = (0, _classnames4.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.SiteHeader__navigation, true), (0, _defineProperty3.default)(_classnames, styles['SiteHeader__navigation--open'], open), (0, _defineProperty3.default)(_classnames, styles['SiteHeader__navigation--hasAccountBar'], loggedIn), _classnames));

      var getPackImage = function getPackImage(id) {
        return (0, _utils.getS3Url)('quixel-megascans-packs-images/' + id + '/nav.jpg');
      };

      var packLinks = packs && packs.map(function (p, i) {
        return _react2.default.createElement(
          'li',
          {
            key: 'pack-link-' + i,
            className: styles.SiteHeader__link + ' ' + styles['SiteHeader__link--pack'],
            style: { backgroundImage: 'url(' + getPackImage(p.id) + ')' } },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: p.isIncomplete ? '/megascans/library/packs/' + p.id : '/packs/' + p.id },
            p.name.replace(/\sPack/, '')
          )
        );
      });

      var sublinksClasses = (0, _classnames4.default)((_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, styles.SiteHeader__subLinks, true), (0, _defineProperty3.default)(_classnames2, styles['SiteHeader__subLinks--hidden'], getMegascansDropdownHidden), _classnames2));

      return _react2.default.createElement(
        'div',
        { className: classes },
        _react2.default.createElement(
          'div',
          { className: styles.SiteHeader__link + ' ' + styles.SiteHeader__getMegascans, onClick: this.handleGetMegascansClicked.bind(this) },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/pricing' },
            'Get Megascans'
          ),
          _react2.default.createElement(
            'div',
            { className: sublinksClasses },
            _react2.default.createElement('span', { className: styles['SiteHeader__mini-profile-angle'] }),
            _react2.default.createElement(
              'ul',
              { className: styles.SiteHeader__links },
              _react2.default.createElement(
                'li',
                { className: styles.SiteHeader__link + ' ' + styles.SiteHeader__getSubscriptionLink },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/pricing' },
                  'Get Subscription',
                  _react2.default.createElement(
                    'span',
                    { className: styles.SiteHeader__linkDescription },
                    'Annual or monthly subscriptions. Cancel anytime.'
                  )
                )
              ),
              _react2.default.createElement(
                'li',
                { className: styles.SiteHeader__link },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/megascans/library/packs' },
                  'Get Packs',
                  _react2.default.createElement(
                    'span',
                    { className: styles.SiteHeader__linkDescription },
                    'Standalone packs. Yours forever!'
                  )
                ),
                _react2.default.createElement(
                  'ul',
                  { className: styles.SiteHeader__subLinks + ' ' + styles['SiteHeader__subLinks--packs'] },
                  packLinks
                )
              )
            )
          )
        ),
        _react2.default.createElement('span', { className: styles.SiteHeader__navigationSwitch, onClick: this.handleNavSwitchClick }),
        _react2.default.createElement(
          'div',
          { className: styles.SiteHeader__linksWrap },
          _react2.default.createElement('span', { className: styles.SiteHeader__linksAngle }),
          _react2.default.createElement(
            'ul',
            { className: styles.SiteHeader__links },
            _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/types/everything' },
                'Library'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/megascans/library/free' },
                'Free'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/gallery' },
                'Gallery'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link },
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/blog' },
                'Blog'
              )
            ),
            _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link },
              _react2.default.createElement(
                'a',
                { href: '/faq', target: '_blank' },
                'FAQ'
              )
            ),
            !loggedIn && _react2.default.createElement(
              'li',
              { className: styles.SiteHeader__link + ' ' + styles['SiteHeader__link--withSeparator'] },
              _react2.default.createElement(
                _reactRouter.Link,
                { className: styles.SiteHeader__loginLink, to: '/login' },
                'Sign In'
              )
            )
          )
        ),
        loggedIn && _react2.default.createElement(
          'span',
          { className: '' + styles.SiteHeader__accountBar },
          _react2.default.createElement(_components.AccountBar, null)
        )
      );
    }
  }]);
  return SiteHeaderNav;
}(_react2.default.Component);

exports.default = SiteHeaderNav;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SiteHeaderNav/SiteHeaderNav.jsx
// module id = 2738
// module chunks = 0